import bulders1 from "../../assets/gallary-image/iconic and bulders.jpeg";
import bulders2 from "../../assets/gallary-image/bulders.jpeg";
import blog_img_05 from "../../assets/gallary-image/blog_img_05.jpeg";
import blog_img_16 from "../../assets/gallary-image/galary2.jpeg";
import blog_img_14 from "../../assets/gallary-image/galary1.jpeg";
import blog_img_06 from "../../assets/gallary-image/blog_img_06.jpeg";
import blog_img_07 from "../../assets/gallary-image/blog_img_07.jpeg";
import blog_img_09 from "../../assets/gallary-image/blog_img_09.jpeg";
import blog_img_01 from "../../assets/gallary-image/blog_img_01.jpeg";
import blog_img_02 from "../../assets/gallary-image/blog_img_02.jpeg";
import blog_img_03 from "../../assets/gallary-image/blog_img_03.jpeg";
import blog_img_04 from "../../assets/gallary-image/blog_img_04.jpeg";
import blog_img_10 from "../../assets/gallary-image/galary4.jpeg";
import blog_img_15 from "../../assets/gallary-image/galary3.jpeg";
import blog_img_12 from "../../assets/gallary-image/galary5.jpeg";
import blog_img_13 from "../../assets/gallary-image/galary7.jpeg";

export const blogPosts = [
  // ========== 1. Partnership ==========
  {
    id: 1,
    slug: "iconic-city-partnership-with-our-builder",
    title: "Iconic City Begins: Historic Partnership with Our Builder Ltd.",
    excerpt:
      "On 12 March 2025, Iconic Greenland Ltd. and Our Builder Ltd. signed a landmark agreement to jointly develop Iconic City a commitment to quality, trust, and sustainable growth.",
    category: "real-estate",
    categoryLabel: "Real Estate",
    author: "Iconic Greenland",
    date: "Mar 12, 2025",
    readTime: "4 min read",
    image: bulders1,
    featured: true,
    intro:
      "Every great project starts with the right partnership. Iconic City officially began its journey when Iconic Greenland Ltd. joined hands with Our Builder Ltd. in a formal signing ceremony.",
    highlights: ["Signing Ceremony", "Strategic Partnership", "Shared Vision"],
    sections: [
      {
        heading: "A partnership built on trust",
        body: "On 12 March 2025, representatives from both companies came together to formalize their collaboration. The agreement focused on delivering high-quality construction, transparent project management, and long-term value for future residents of Iconic City.",
      },
      {
        heading: "Strengthening the foundation for success",
        body: "This partnership combines Iconic Greenland’s vision for sustainable communities with Our Builder Ltd.’s construction expertise creating a strong platform for the entire project.",
      },
    ],
    images: [bulders1, bulders2],
    relatedNote:
      "Strong partnerships are the first step toward building lasting communities.",
  },

  // ========== 2. Planning & Office Meetings ==========
  {
    id: 2,
    slug: "iconic-city-planning-and-coordination",
    title: "Behind the Scenes: Planning Iconic City with Clarity and Care",
    excerpt:
      "Regular internal meetings and careful coordination at the Iconic Greenland office ensure every decision supports quality, timeline, and long-term livability.",
    category: "real-estate",
    categoryLabel: "Real Estate",
    author: "Iconic Greenland",
    date: "Apr 2025",
    readTime: "4 min read",
    image: blog_img_05,
    featured: false,
    intro:
      "Great projects are not only built on site — they are carefully planned in meeting rooms. Iconic Greenland maintains clear communication and strategic alignment at every stage.",
    highlights: ["Team Coordination", "Strategic Planning", "Quality Focus"],
    sections: [
      {
        heading: "Clear communication drives progress",
        body: "Regular meetings at the Iconic Greenland office bring the team together to review progress, discuss challenges, and align on next steps. These sessions help keep the project focused and efficient.",
      },
      {
        heading: "Decisions that protect long-term value",
        body: "From design details to construction sequencing, every decision is made with future residents in mind ensuring Iconic City delivers both quality and livability.",
      },
    ],
    images: [blog_img_05],
    relatedNote:
      "Careful planning today creates stronger communities tomorrow.",
  },

  // ========== 3. Foundation Stone Ceremony ==========
  {
    id: 3,
    slug: "iconic-city-foundation-stone-ceremony",
    title: "Foundation Stone Laid: Iconic City Officially Begins",
    excerpt:
      "With prayers and the symbolic placement of the first bricks, Iconic City marked its official start a moment of spiritual sincerity and professional commitment.",
    category: "real-estate",
    categoryLabel: "Real Estate",
    author: "Iconic Greenland",
    date: "2025",
    readTime: "5 min read",
    image: blog_img_16,
    featured: false,
    intro:
      "The foundation stone ceremony is more than a formal event it is the moment a vision becomes real. Iconic City began its physical journey with faith, unity, and purpose.",
    highlights: ["Foundation Ceremony", "Community Blessing", "Symbolic Start"],
    sections: [
      {
        heading: "A moment of unity and prayer",
        body: "Team members, partners, and community representatives gathered for the foundation stone ceremony. Prayers were offered and the first bricks were placed, marking the official beginning of construction.",
      },
      {
        heading: "From vision to reality",
        body: "This ceremony reflected both spiritual sincerity and professional commitment setting a strong tone for the entire development journey of Iconic City.",
      },
    ],
    images: [blog_img_16, blog_img_14],
    relatedNote:
      "Every lasting structure begins with a solid foundation — both physical and spiritual.",
  },

  // ========== 4. Community Engagement ==========
  {
    id: 4,
    slug: "iconic-city-community-engagement",
    title: "Building Trust: Iconic City Connects with the Community",
    excerpt:
      "Through gatherings, discussion programs, and shared meals, Iconic Greenland keeps local residents informed and involved turning a construction project into a shared neighborhood story.",
    category: "real-estate",
    categoryLabel: "Real Estate",
    author: "Iconic Greenland",
    date: "2025",
    readTime: "5 min read",
    image: blog_img_07,
    featured: false,
    intro:
      "True development succeeds when people feel included. Iconic Greenland actively engages the surrounding community through open events and meaningful interaction.",
    highlights: ["Community Programs", "Open Discussion", "Shared Meals"],
    sections: [
      {
        heading: "Events that build belonging",
        body: "Large gatherings under decorated tents bring residents, partners, and the project team together. These programs create space for dialogue, updates, and mutual understanding.",
      },
      {
        heading: "Shared meals, shared stories",
        body: "Community meals and informal interactions further strengthen relationships — helping Iconic City become more than a project, but a part of the local neighborhood fabric.",
      },
    ],
    images: [blog_img_07, blog_img_09, blog_img_06],
    relatedNote:
      "When communities are included, development becomes more meaningful and sustainable.",
  },

  // ========== 5. Early Construction Work ==========
  {
    id: 5,
    slug: "iconic-city-early-construction-progress",
    title: "On-Site Momentum: Early Construction of Iconic City",
    excerpt:
      "From group coordination and crane operations to rebar work, the Iconic City site is now fully active reflecting disciplined teamwork and steady progress.",
    category: "real-estate",
    categoryLabel: "Real Estate",
    author: "Iconic Greenland",
    date: "2025–2026",
    readTime: "5 min read",
    image: blog_img_02,
    featured: false,
    intro:
      "With the foundation complete, construction teams have moved into full activity. Iconic City’s early site work shows strong coordination and professional execution.",
    highlights: ["Site Teamwork", "Crane Operations", "Rebar & Structure"],
    sections: [
      {
        heading: "Teamwork on the ground",
        body: "Workers and supervisors gather regularly on site to coordinate tasks. These moments of collective focus help maintain safety, quality, and momentum across different work zones.",
      },
      {
        heading: "Heavy equipment and skilled hands",
        body: "Cranes, rebar binding, and structural preparation are now underway. Every stage reflects careful workmanship as the project advances toward its planned residential towers.",
      },
    ],
    images: [blog_img_01, blog_img_03, blog_img_02, blog_img_04],
    relatedNote:
      "Consistent on-site discipline is what turns plans into lasting structures.",
  },

  // ========== 6. Foundation & Brickwork ==========
  {
    id: 6,
    slug: "iconic-city-foundation-and-brickwork",
    title: "Building the Base: Foundation and Brickwork at Iconic City",
    excerpt:
      "Careful foundation work and precise brick laying form the solid base of Iconic City ensuring strength, durability, and long-term structural integrity.",
    category: "real-estate",
    categoryLabel: "Real Estate",
    author: "Iconic Greenland",
    date: "2026",
    readTime: "4 min read",
    image: blog_img_10,
    featured: false,
    intro:
      "The strength of any building begins below the surface. At Iconic City, foundation and brickwork are being executed with precision and care.",
    highlights: ["Foundation Work", "Brick Laying", "Structural Strength"],
    sections: [
      {
        heading: "Precision at the foundation level",
        body: "Workers carefully prepare and strengthen the foundation using proper tools and techniques. This stage is critical for the long-term stability of the entire development.",
      },
      {
        heading: "Brick by brick, progress continues",
        body: "Brickwork is progressing steadily across the site. Clean lines, proper alignment, and consistent quality mark this important phase of construction.",
      },
    ],
    images: [blog_img_10, blog_img_15],
    relatedNote:
      "A strong base is the quiet foundation of every successful building.",
  },

  // ========== 7. Current Progress & Future ==========
  {
    id: 7,
    slug: "iconic-city-current-progress-and-future",
    title: "Iconic City Today: Visible Progress Toward a Sustainable Community",
    excerpt:
      "Billboards for City Tower now stand along the surrounding area, while foundation and structural work continue Iconic City is steadily taking shape.",
    category: "real-estate",
    categoryLabel: "Real Estate",
    author: "Iconic Greenland",
    date: "Aug 2026",
    readTime: "5 min read",
    image: blog_img_12,
    featured: true,
    intro:
      "What began as a partnership and a foundation ceremony is now clearly visible on the ground. Iconic City continues to move forward with clarity and purpose.",
    highlights: [
      "Site Visibility",
      "City Tower Billboard",
      "Ongoing Development",
    ],
    sections: [
      {
        heading: "A visible presence in the neighborhood",
        body: "Billboards for City Tower and active construction work now mark the presence of Iconic City. The project is no longer just a plan — it is becoming part of the local landscape.",
      },
      {
        heading: "Looking ahead with confidence",
        body: "With steady progress on foundation and structure, Iconic Greenland remains focused on delivering a modern residential development designed for long-term community living and sustainable value.",
      },
    ],
    images: [blog_img_12, blog_img_13],
    relatedNote:
      "Iconic City is more than a building project — it is a long-term commitment to quality, partnership, and community.",
  },
];

export const categoryLabels = {
  all: "All Posts",
  technology: "Technology",
  business: "Business",
  "real-estate": "Real Estate",
  transport: "Transport",
  travel: "Travel",
  automotive: "Automotive",
  lifestyle: "Lifestyle",
};
